import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  isDarkMode = new BehaviorSubject<boolean>(false);
  private readonly THEME_KEY = 'theme';

  constructor() {
    // Recupera il tema salvato se presente
    const savedTheme = localStorage.getItem(this.THEME_KEY);
    if (savedTheme) {
      this.setTheme(savedTheme === 'dark');
    }
  }

  detectSystemTheme() {
    // Imposta sempre il tema chiaro di default
    this.setTheme(false);
  }

  isDarkModeValue(): boolean {
    return this.isDarkMode.getValue();
  }
  
  private setTheme(isDark: boolean) {
    // Rimuovi tutte le classi di tema
    document.body.classList.remove('light', 'dark');
    
    // Imposta il nuovo tema
    document.body.classList.add(isDark ? 'dark' : 'light');
    this.isDarkMode.next(isDark);
    
    // Salva il tema nelle preferenze
    localStorage.setItem(this.THEME_KEY, isDark ? 'dark' : 'light');
  }

  onThemeToggle() {
    this.setTheme(!this.isDarkMode.getValue());
  }
}
